export enum InvoiceStatus {
  UNPAID = 'pending',
  DRAFT = 'draft',
  PAID = 'paid',
  EXPIRED = 'expired',
  RETURNED = 'refunded',
  DISPUTED = 'in_protest',
  CHARGEBACK = 'chargeback',
  CANCELED = 'canceled', // only smart installment
}
